import { Box } from '../../shared-components/Box';
import { Row } from './Row';
import { useContent, Content } from './ContentProvider';

export const PDF_WIDTH = 1080;

const getStyles = ({ mediaType, root, globalSettings, sectionProperties }) => {
  const { backgroundColor = '', ...customStyles } = sectionProperties?.style || {};
  const isFullScreen = sectionProperties?.fullScreenWidth;

  const pdfSectionDefaults = {
    width: '100%',
    maxWidth: `calc(${PDF_WIDTH}px - ${globalSettings?.margins?.left}in - ${globalSettings?.margins?.right}in)`,
    minWidth: '0',
    margin: '-2px',
  };

  const sectionBackgroundSize = mediaType === 'pdf' ? pdfSectionDefaults : {};
  const sectionSize =
    mediaType === 'pdf'
      ? {
          ...pdfSectionDefaults,
          maxWidth: `calc(${PDF_WIDTH}px - ${globalSettings?.margins?.left}in - ${globalSettings?.margins?.right}in + 2px)`,
        }
      : {};

  const backgroundSize = isFullScreen
    ? { width: '100%', maxWidth: '100%', minWidth: '100%' }
    : {
        width: '100%',
        maxWidth: root?.style?.maxWidth,
        minWidth: root?.style?.minWidth,
        ...sectionBackgroundSize,
      };

  const background = {
    backgroundColor: backgroundColor || 'rgba(0, 0, 0, 0)',
    ...backgroundSize,
    ...customStyles,
  };

  return {
    container: isFullScreen ? customStyles : {},
    section: {
      ...root?.style,
      ...(!isFullScreen ? customStyles : {}),
      ...sectionSize,
    },
    background,
  };
};

const getRowClasslist = (properties) => {
  // const hasBenefits = data?.columns?.some((column) => {
  //   if (column.type === 'list') {
  //     return data?.list?.some((item) => item.component === 'benefits');
  //   }
  //   return column?.component === 'benefits';
  // });
  let classList = ['row'];

  if (properties?.hideOnMobile && properties?.hideOnDesktop) {
    classList.push('non-viewable');
  } else if (properties?.hideOnMobile) {
    classList.push('desktop-only');
  } else if (properties?.hideOnDesktop) {
    classList.push('mobile-only');
  }

  // if (properties?.stackColumns || hasBenefits) {
  //   classList.push('stack-columns');
  // }

  return classList.join(' ');
};

// mobile/desktop views are handled in css (via media queries) aka the `getRowClassList` function.
// We may want to standardize this in the future, but for now, we are keeping it as is.
const getCanViewSection = (mediaType, properties) => {
  if (mediaType === 'pdf' && properties?.hideOnExport) {
    return false;
  }
  return true;
};

export const Section = ({ id }) => {
  const content = useContent();
  const globalSettings = Content.getGlobalSettings(content);
  const mediaType = Content.getViewMode(content, id);
  const root = Content.getRoot(content);
  const block = Content.get(content, id);
  const styles = getStyles({
    mediaType,
    root,
    globalSettings,
    sectionProperties: block?.properties,
  });
  const classes = getRowClasslist(block?.properties);

  const children = Content.getChildrenById(content, id);
  const hasChildren = children?.length > 0;
  const canViewSection = getCanViewSection(mediaType, block?.properties);

  if (!canViewSection || !hasChildren) {
    return null;
  }

  return (
    <Box
      flex="center"
      className={classes}
      css={`
        position: relative;
        box-sizing: border-box;
        a {
          color: inherit;
          text-decoration: inherit;
        }
      `}
      style={styles.container}
    >
      <Box
        css={`
          position: absolute;
          top: 0;
          bottom: 0;
          margin: 0 auto;
          z-index: 0;
          pointer-events: none;
          box-sizing: border-box;
        `}
        style={styles.background}
      />
      <Box
        style={styles.section}
        css={`
          z-index: 1;
          box-sizing: border-box;
        `}
      >
        {block?.children?.map((child) => (
          <Row key={child?.id} id={child?.id} />
        ))}
      </Box>
    </Box>
  );
};
